/**
 * Nhãn + màu Tag + nhóm bước cho trạng thái pipeline bài viết AI (khớp content_items.status BE).
 * running = tick đang tự xử lý (FE poll); paused = chờ user duyệt; terminal = kết thúc.
 */
export const STATUS_META = {
	intent:         {label: 'Phân tích search intent', color: 'processing', step: 0},
	outline:        {label: 'Đang lên dàn ý',          color: 'processing', step: 1},
	outline_review: {label: 'Chờ duyệt dàn ý',         color: 'warning',    step: 1},
	write:          {label: 'Đang viết bài',           color: 'processing', step: 2},
	images:         {label: 'Đang chèn ảnh',           color: 'processing', step: 3},
	check:          {label: 'Đang kiểm tra SEO',       color: 'processing', step: 4},
	revise:         {label: 'Đang sửa theo checklist', color: 'processing', step: 4},
	review:         {label: 'Chờ duyệt bài',           color: 'warning',    step: 5},
	done:           {label: 'Hoàn tất',                color: 'success',    step: 5},
	publishing:     {label: 'Đang đăng lên kênh',      color: 'processing', step: 5},
	published:      {label: 'Đã đăng',                 color: 'green',      step: 5},
	failed:         {label: 'Lỗi',                     color: 'error',      step: -1},
};

/** Các bước hiển thị trên thanh tiến trình của viewer. */
export const PIPELINE_STEPS = ['Search intent', 'Dàn ý', 'Viết bài', 'Hình ảnh', 'Checklist SEO', 'Hoàn tất'];

export const statusMeta = (status) => STATUS_META[status] || {label: status, color: 'default', step: 0};
